<template>
    <div>
        <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.99999 181.33333" height="100.33333" xml:space="preserve" id="svg2" version="1.1">
            <metadata id="metadata8">
                <rdf:RDF>
                    <cc:Work rdf:about="">
                        <dc:format>image/svg+xml</dc:format>
                        <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                        <dc:title></dc:title>
                    </cc:Work>
                </rdf:RDF>
            </metadata>
            <defs id="defs6">
                <clipPath id="clipPath18" clipPathUnits="userSpaceOnUse">
                    <path id="path16" d="M 0,1695.119 H 1201.888 V 0 H 0 Z" />
                </clipPath>
            </defs>
            <g transform="matrix(1.3333333,0,0,-1.3333333,-488.22585,970.59891)" id="g10">
                <g id="g12">
                    <g clip-path="url(#clipPath18)" id="g14">
                        <g transform="translate(725.6694,604.4492)" id="g20">
                            <path id="path22" style="fill:#b2ca35;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 0,0 c 0,-6.627 -5.373,-12 -12,-12 h -335 c -6.627,0 -12,5.373 -12,12 v 111 c 0,6.627 5.373,12 12,12 h 335 c 6.627,0 12,-5.373 12,-12 z" />
                        </g>
                        <g transform="translate(725.6694,604.4492)" id="g24">
                            <path id="path26" style="fill:none;stroke:#ffffff;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 0,0 c 0,-6.627 -5.373,-12 -12,-12 h -335 c -6.627,0 -12,5.373 -12,12 v 111 c 0,6.627 5.373,12 12,12 h 335 c 6.627,0 12,-5.373 12,-12 z" />
                        </g>
                        <g transform="translate(713.1694,617.7695)" id="g28">
                            <path id="path30" style="fill:none;stroke:#ffffff;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" d="m 0,0 c 0,-7.356 -5.6,-13.32 -12.506,-13.32 h -308.488 c -6.907,0 -12.506,5.964 -12.506,13.32 v 84.359 c 0,7.357 5.599,13.321 12.506,13.321 H -12.506 C -5.6,97.68 0,91.716 0,84.359 Z" />
                        </g>
                    </g>
                </g><text id="text38" style="font-variant:normal;font-weight:bold;font-stretch:normal;font-size:22px;font-family:'arial';-inkscape-font-specification:SegoeUI-Bold;writing-mode:lr-tb;fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none" transform="matrix(1,0,0,-1,435.8608,683.8867)">
                    <tspan id="tspan32" y="0" x="0 11.374 24.816 38.125999 46.882 52.953999 66.594002 75.438004 81.685997 92.246002 104.148 110.22 118.69 132.132 145.75 157.586 169.422 175.494 193.028 199.276 207.834 221.078">Your price today with </tspan>
                    <tspan id="tspan34" y="26.4" x="30.756001 43.405998 49.478001 69.629997 83.071999 96.382004 104.94 118.184 127.864 133.936 147.37601 161.742 175.446 190.14999">3 months FREE!</tspan>
                    <tspan id="tspan36" y="64.790001" x="67.019997 82.67">{{price}}</tspan>
                </text>
            </g>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "YourPrice",
        data() {
            return {};
        },
        props: {
            price: Number
        },
        methods: {
        }
    };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/YourPrice.vue